import {ApolloClient, createHttpLink, from, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {removeTypenameFromVariables} from '@apollo/client/link/remove-typename';
import {QueryClient} from "@tanstack/react-query";
import axios, {AxiosPromise} from "axios";
import {easasAlert} from "../components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {checkPermission} from "../hooks/useHasPermissions";
import {EASAS_JS_SCRAPER_URL, EASAS_REST_URL} from "../utils/constants";
import { T } from './lang/LanguageService';

export const paramsSerializer = (params: any) => {
    return Object.keys(params)
        .map(key => {
            const value = params[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    // Convert array values to single value
                    return value.map((val: any) => `${key}=${encodeURIComponent(val)}`).join('&');
                } 
                    return `${key}=${encodeURIComponent(value)}`;
                
            }
            return '';
        })
        .filter(param => param !== '')
        .join('&');
};

export const easasJsVersionsSrvAxios = function () {
    return axios.create({
        baseURL: EASAS_JS_SCRAPER_URL()
    })
}()

let authErrorHandled = false

export const easasAxios = function () {
    const client = axios.create({
        baseURL: EASAS_REST_URL(),
        paramsSerializer: {serialize: paramsSerializer}
    });

    client.interceptors.response.use(
        (response) => {
        // Do something with response data
        return response;
    }, (error) => {
        // Do something with response error
        if (!authErrorHandled) {
          if (error.response?.status === 401) {
            easasAlert({
              summary: T("alert-session-timed-out"),
              detail: T("alert.please-re-login-by-refreshing-the-page"),
              severity: "error",
            });
            authErrorHandled = true
          } else if (checkPermission("ADMIN")) {
            easasAlert({
              summary: T("alert.network-error-internal"),
              detail: error.response?.data?.message,
              severity: "error",
            });
            authErrorHandled = true
          }
        }   
        return Promise.reject(error);
    });


    return client
}()

export const queryClient = new QueryClient();

const httpLink = createHttpLink({
  uri: process.env.GRAPHQL_API,
});

const link = from([removeTypenameFromVariables(), httpLink])

const authLink = setContext(async (_, { headers }) => {
    // const token
    return {
      headers: {
        ...headers,
        // authorization: token ? `Bearer ${token.data}` : "",
      }
    }
})

export const apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache({
    typePolicies: {
      AnalyticsResultDTO: {
        keyFields: ["id", "mdmDevice", ["identifier"], "mdmObject", ["id"]],
      },
    }
  }),
});

export type APIError = { message?: string; data?: string; status?: number };
export type APIResponse<T> = { data?: T; error?: APIError };
export type APIPromise<T> = Promise<APIResponse<T>>;


export function requestPromiseTypeWrapper<T>(promise: AxiosPromise<T>, objMapperFn?: (data: Partial<T>) => T): APIPromise<T> {
    return promise.then((res) => {
        if(objMapperFn) {
            return ({data: objMapperFn(res.data)});
        } 
            return {data: res.data};
        
    }).catch((error: any) => {
        return {error: error.response?.data};
    })
}